import styled from "styled-components";

interface IInputTextReactPrime {
  disabled?: any;
  colorBorder?: string;
  fontSize?: string;
  height?: string;
  width?: string;
  maxWidth?: string;
  maxheight?: string;
}

export const InputTextReactPrime = styled.div<IInputTextReactPrime>`
  ${(props) => `
  cursor: ${props.disabled ? "not-allowed" : "pointer"};
  .input-text-react-prime{
    background: ${props.disabled ? "#E7E7EA" : "#FFFFFF"};
    border-radius: 8px;
    border: 1px solid ${props.colorBorder ? props.colorBorder : "#ffffff"};
    box-shadow: 0px 5px 30px rgba(231, 231, 234, 0.62);
    font-family: ${props.theme.fontFamilies.primaryFont};
    font-size: ${props.fontSize ? props.fontSize : "1.4rem"};
    height: ${props.height ? props.height : "5rem"};
    padding: 1.5rem;
    width: ${props.width ? props.width : "25rem"};
    max-width:${props.maxWidth ? props.maxWidth : "100%"};
    max-height:${props.maxheight ? props.maxheight : "100%"};
  }
  `}

  .input-text-react-prime:enabled:focus {
    border-color: #000000;
    box-shadow: 0 0 0 0.2rem #7575750f;
    outline-offset: 0;
    outline: 0 none;
  }

  .input-text-react-prime:enabled:hover {
    border-color: #000000;
  }
`;

interface IInputNumberReactPrime {
  disabled?: any;
  colorBorder?: string;
  fontSize?: string;
  height?: string;
  width?: string;
}
export const InputNumberReactPrime = styled.div<IInputNumberReactPrime>`
  ${(props) => `
  cursor: ${props.disabled ? "not-allowed" : "pointer"};
  .input-number-react-prime {
    .p-inputnumber-input {
      background: ${props.disabled ? "#E7E7EA" : "#FFFFFF"};
      border-radius: 8px;
      border: 1px solid ${props.colorBorder ? props.colorBorder : "#ffffff"};
      box-shadow: 0px 5px 30px rgba(231, 231, 234, 0.62);
      font-family: ${props.theme.fontFamilies.primaryFont};
      font-size: ${props.fontSize ? props.fontSize : "1.4rem"};
      height: ${props.height ? props.height : "5rem"};
      padding: 1.5rem;
      width: ${props.width ? props.width : "25rem"};
    }
  }
  `}
`;

interface IMainButton {
  backgroundColor?: string;
  fontSize?: string;
  height?: string;
  width?: string;
  isDisabled?: boolean;
}

export const MainButton = styled.button<IMainButton>`
  ${(props) => `
background-color: ${props.backgroundColor ? props.backgroundColor : "#88B13B"};
cursor: ${props.disabled ? "not-allowed" : "pointer"};
font-family: ${props.theme.fontFamilies.primaryFont};
font-size: ${props.fontSize ? props.fontSize : "1.5rem"};
height: ${props.height ? props.height : "5rem"};
width: ${props.width ? props.width : "100%"}; 
`}
  align-items: center;
  border-radius: 8px;
  border: none;
  color: ${(props) => props.theme.colors.white};
  display: flex;
  font-weight: 700;
  justify-content: center;
  .icon {
    height: 5rem;
    width: 5rem;
  }
  .icon-height-width {
    height: 1.2rem;
    width: 0.8rem;
  }
  :disabled,
  [disabled] {
    background-color: ${(props) =>
      props.backgroundColor + props.theme.transparencies.p20};
  }
`;

interface IButtonReload {
  backgroundColor?: string;
  fontSize?: string;
  height?: string;
  width?: string;
  marginTop?: string;
}
export const ButtonReload = styled.button<IButtonReload>`
  ${(props) => `
background-color: ${props.backgroundColor ? props.backgroundColor : "#88B13B"};
cursor: ${props.disabled ? "not-allowed" : "pointer"};
font-family: ${props.theme.fontFamilies.primaryFont};
font-size: ${props.fontSize ? props.fontSize : "1.5rem"};
height: ${props.height ? props.height : "5rem"};
width: ${props.width ? props.width : "100%"}; 
margin-top: ${props.marginTop ? props.marginTop : "0rem"}; ;
}
`}
  align-items: center;
  border-radius: 8px;
  border: none;
  color: ${(props) => props.theme.colors.white};
  display: flex;
  font-weight: 700;
  justify-content: center;
  .icon {
    height: 5rem;
    width: 5rem;
  }
  .icon-reload {
    height: 1.5rem;
    width: 1.5rem;
  }
  .icon-height-width {
    height: 1.2rem;
    width: 0.8rem;
  }
`;

interface IMultiSelectReactPrime {
  disabled?: any;
  fontSize?: string;
  height?: string;
  width?: string;
}
export const MultiSelectReactPrime = styled.div<IMultiSelectReactPrime>`
  ${(props) => `
    cursor: ${props.disabled ? "not-allowed" : "pointer"};
    .multiselect-react-prime{
      align-items: center;
      background: ${props.disabled ? "#E7E7EA" : "#FFFFFF"};
      border-radius: 8px;
      border: 1px solid #ffffff;
      box-shadow: 0px 5px 30px rgba(231, 231, 234, 0.62);
      display: flex;
      font-family: ${props.theme.fontFamilies.primaryFont};
      font-size: ${props.fontSize ? props.fontSize : "1.4rem"};
      height: ${props.height ? props.height : "5rem"};
      padding-left: 1.5rem;
      width: ${props.width ? props.width : "100%"};
      @media (max-width: 750px) {
        width: 100%;
      }
    }
    `}
  .multiselect-react-prime:enabled:focus {
    border-color: #000000;
    box-shadow: 0 0 0 0.2rem #7575750f;
    outline-offset: 0;
    outline: 0 none;
  }
  .multiselect-react-prime:enabled:hover {
    border-color: #000000;
  }
  .multiselect-react-prime .p-multiselect-label {
    padding: 0.3rem;
    transition: background-color 0.2s, color 0.2s, border-color 0.2s,
      box-shadow 0.2s;
  }
  .multiselect-icon-chip
    .p-multiselect-label-container
    .p-multiselect-label
    .p-multiselect-token {
    background: rgba(23, 21, 120, 0.1);
    border-radius: 8px;
    height: 3rem;
  }
  .multiselect-icon-chip {
    border-radius: 0.8rem;
    box-shadow: 0rem 0.5rem 2rem rgba(231, 231, 234, 0.62);
    box-sizing: border-box;
    font-family: Montserrat;
    font-size: 1.4rem;
    font-size: 1.5rem;
    font-weight: 500;
    height: 5rem;
    margin-top: 1rem;
    ::-webkit-outer-spin-button,
    ::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  }
  .multiselect-react-prime:not(.p-disabled):hover {
    border-color: #000000;
  }
  .multiselect-react-prime:not(.p-disabled).p-focus {
    border-color: #000000;
    box-shadow: 0 0 0 0.2rem #7575750f;
  }
`;

interface IDropdownReactPrime {
  disabled?: any;
  fontSize?: string;
  height?: string;
  width?: string;
}
export const DropdownReactPrime = styled.div<IDropdownReactPrime>`
  ${(props) => `
  cursor: ${props.disabled ? "not-allowed" : "pointer"};
  .dropdown-react-prime{
    background: ${props.disabled ? "#E7E7EA" : "#FFFFFF"};
    border-radius: 8px;
    border: 1px solid #ffffff;
    box-shadow: 0px 5px 30px rgba(231, 231, 234, 0.62);
    font-family: ${props.theme.fontFamilies.primaryFont};
    font-size: ${props.fontSize ? props.fontSize : "1.4rem"};
    height: ${props.height ? props.height : "5rem"};
    width: ${props.width ? props.width : "25rem"};
    flex-direction: row;
  }
  `}
  .dropdown-react-prime {
    align-items: center;
    border: 1px solid #ffffff;
    display: flex;
    font-family: Montserrat;
    padding-left: 1rem;
    padding: 0rem;
  }
  .dropdown-react-prime:enabled:focus {
    border-color: #000000;
    box-shadow: 0 0 0 0.2rem #7575750f;
    outline-offset: 0;
    outline: 0 none;
  }
  .dropdown-react-prime:enabled:hover {
    border-color: #000000;
  }
  .dropdown-react-prime .p-dropdown-label {
    background: transparent;
    border: 0 none;
    font-family: Montserrat;
    font-size: 0.9em;
  }

  .dropdown-react-prime:not(.p-disabled):hover {
    border-color: #000000;
  }
  .dropdown-react-prime:not(.p-disabled).p-focus {
    border-color: #000000;
    box-shadow: 0 0 0 0.2rem #7575750f;
  }
`;

interface IChipsReactPrime {
  disabled?: any;
  height?: string;
  width?: string;
  fontSize?: string;
}

export const ChipsReactPrime = styled.div<IChipsReactPrime>`
  ${(props) => `
  cursor: ${props.disabled ? "not-allowed" : "pointer"};
  input {
    font-size: 1.4rem;
  }
  .chips-react-prime .p-inputtext{
    align-items: flex-start;
    background: ${props.disabled ? "#E7E7EA" : "#FFFFFF"};
    border-radius: 8px;
    border: 1px solid #ffffff;
    box-shadow: 0px 5px 30px rgba(231, 231, 234, 0.62);
    display: flex;
    flex-direction: column;
    height: ${props.height ? props.height : "5rem"};
    width: ${props.width ? props.width : "25rem"};
  }
.p-chips .p-chips-multiple-container .p-chips-token {
    background: #e8e8f2;
    border-radius: 8px;
    color: #495057;
    font-family: Montserrat;
    font-size: 1.4rem;
    height: 3.3rem;
    margin-left: 0.8rem;
    margin-right: 0.5rem;
    margin-top: 0.6rem;
}
.chips-react-prime .p-inputtext .p-chips-input-token input {
  color: #495057;
  font-family: Montserrat;
  font-size: 1.4rem;
  margin-left: 0.8rem;
}
  `}
`;

interface ICalendarReactPrime {
  marginRight?: string;
  disabled?: any;
  width?: string;
  height?: string;
  fontSize?: string;
}

export const CalendarReactPrime = styled.div<ICalendarReactPrime>`
  .custom-height-width {
    height: 5rem;
    width: 100%;
  }
`;

interface IDivLabelButton {
  marginRight?: string;
}
export const DivLabelButton = styled.div<IDivLabelButton>`
  ${(props) => `
margin-right: ${props.marginRight ? "1rem" : "0rem"};

`}
`;

interface IDivDamPrefix {
  marginRight?: string;
}
export const DivDamPrefix = styled.div<IDivDamPrefix>`
  ${(props) => `
    align-items: center;
    background-color: ${props.theme.colors.primaryBlue};
    border-radius: 1rem 0 0 1rem;
    color: ${props.theme.colors.white};
    display: flex;
    font-size: 1.5rem;
    font-weight: 500;
    justify-content: center;
    margin-right: ${props.marginRight ? "1rem" : "0rem"};
    padding-left: 0.5rem;
    width: 25.5rem;
`}
`;

export const Ptitle = styled.p`
  ${(props) => `
    font-family: ${props.theme.fontFamilies.primaryFont};
    color: #08082B;
    font-size: 1.4rem;
    font-weight: 600;
`}
`;
